import { IconFinanceArrowBoldUp16, IconFinanceArrowBoldDown16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { EDiffPriceTrand } from '../../../repositories/valuation-offer-history/entities/market_trand/GetMarketTrandResponseSchema';

interface IUseGetDiffParams {
  diffPriceTrand: EDiffPriceTrand;
  diffPrice: string | null;
  diffPercent: string | null;
}

interface IUseGetDiffReturnValue {
  text: string;
  icon: React.ReactElement | null;
  diffPercent: string | null;
}

const initialState = {
  text: '+0 ₽',
  icon: null,
  diffPercent: '+0%',
};
export function useGetDiff({ diffPriceTrand, diffPrice, diffPercent }: IUseGetDiffParams): IUseGetDiffReturnValue {
  switch (diffPriceTrand) {
    case EDiffPriceTrand.Increase:
      return {
        text: `+${diffPrice}` as string,
        icon: <IconFinanceArrowBoldUp16 color="icon-main-default" />,
        diffPercent: `+${diffPercent}`,
      };
    case EDiffPriceTrand.Decrease:
      return {
        text: `−${diffPrice}` as string,
        icon: <IconFinanceArrowBoldDown16 color="icon-main-default" />,
        diffPercent: `−${diffPercent}`,
      };
    default:
      return initialState;
  }
}
